export const formatPriceWithCurrency = (currency = 'EUR') => {
    // de-DE or window.navigator.language
    return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency
    })
}
